import { APIProcessName } from "@common/constants/process-names";

export function getCoaTemplatePreviewSubtitle(sourceType: string): string {
    if (sourceType === APIProcessName.CHART_OF_ACCOUNTS_TEMPLATE_APPLY_UNDO) {
        return "Review what was reverted";
    }
    if (
        sourceType === APIProcessName.ORGANIZATION_CREATE_CLIENT ||
        sourceType === APIProcessName.ENTITY_CREATE
    ) {
        return "Review what was set up";
    }
    return "Review what was applied";
}
